import React, { useContext } from 'react';
import { IComponentIFrame } from '../../component.d';

const AllForIFrame = function(props: { url: string }) {
  const { url } = props;

  return <iframe width="100%" height="100%" src={url}></iframe>;
};

export default AllForIFrame;
